import { Component, input, output, computed, ContentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule, Sort } from '@angular/material/sort';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'dhats-table',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatSortModule, TranslocoPipe],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  data = input<any[]>([]);
  columns = input<{ key: string; label: string }[]>([]);
  sortableColumns = input<string[]>([]);
  
  sortChange = output<{ key: string; direction: 'asc' | 'desc' | null }>();
  
  @ContentChild('cellTemplate') cellTemplate?: TemplateRef<any>;

  displayedColumns = computed(() => this.columns().map(c => c.key));

  onMatSortChange(sort: Sort): void {
    const direction = sort.direction === '' ? null : (sort.direction as 'asc' | 'desc');
    this.sortChange.emit({ key: sort.active, direction });
  }
}
